import React from 'react'
import { useAction } from '~/hooks'
import * as Actions from '~/actions'

export default function QRCodeDialog({ children }) {
  const showQRCodeDialog = useAction(Actions.mainView.showQRCodeDialog, true)

  return (
    <div onClick={showQRCodeDialog}>
      {children}
    </div>
  )
}
